export const DEFAULT_VEHICLE_BRANDS = [
  "Abarth",
  "Alfa Romeo",
  "Alpine",
  "Aston Martin",
  "Audi",
  "Bentley",
  "BMW",
  "BYD",
  "Citroën",
  "Cupra",
  "Dacia",
  "DS Automobiles",
  "Ferrari",
  "Fiat",
  "Ford",
  "Honda",
  "Hyundai",
  "Isuzu",
  "Jaguar",
  "Jeep",
  "Kia",
  "Lamborghini",
  "Land Rover",
  "Lexus",
  "Lotus",
  "Maserati",
  "Mazda",
  "McLaren",
  "Mercedes-Benz",
  "MG",
  "MINI",
  "Mitsubishi",
  "Nissan",
  "Opel",
  "Peugeot",
  "Polestar",
  "Porsche",
  "Renault",
  "Rolls-Royce",
  "SEAT",
  "Škoda",
  "Smart",
  "Subaru",
  "Suzuki",
  "Tesla",
  "Toyota",
  "Volkswagen",
  "Volvo",
] as const;

export function normalizeVehicleBrands(value: unknown): string[] {
  const source = Array.isArray(value) ? value : DEFAULT_VEHICLE_BRANDS;
  return [...new Set(source.map((item) => String(item).trim()).filter(Boolean))]
    .sort((left, right) => left.localeCompare(right, "pt-PT"));
}
